import { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./AuthContext";
import "./i18n";

let App;
const rootPath = window.location.pathname.split("/").slice(0, 3).join("/");
switch (rootPath) {
    case "/tools/configure":
        App = lazy(() => import("./configure/App" /* webpackChunkName: "configure" */));
        break;
    case "/tools/fertilize":
        App = lazy(() => import("./fertilize/App" /* webpackChunkName: "fertilize" */));
        break;
    case "/tools/sow":
        App = lazy(() => import("./sow/App" /* webpackChunkName: "sow" */));
        break;
    case "/tools/admin":
        App = lazy(() => import("./admin/App" /* webpackChunkName: "admin" */));
        break;
    case "/tools/drive":
        App = lazy(() => import("./drive/App" /* webpackChunkName: "drive" */));
        break;
    case "/tools/dora":
        window.location.assign("https://dora." + window.location.hostname.replace("app.", ""));
        break;
    case "/tools/pasture":
        window.location.assign("https://pasture." + window.location.hostname.replace("app.", ""));
        break;
    case "/tools/soil":
        window.location.assign("https://soil." + window.location.hostname.replace("app.", "") + "/map");
        break;
    case "/tools/myfarmiq":
        window.location.assign("https://myfarmiq." + window.location.hostname.replace("app.", "") + "");
        break;
    default:
        App = lazy(() => import("./index/App" /* webpackChunkName: "index" */));
        break;
}

if (App) {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<AuthProvider><Suspense><App /></Suspense></AuthProvider>);
}

